/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Datos recibidos del formulario de creación.
 */
export interface CreateTeamRequest { 
    name: string;
    stadium?: string | null;
    location?: string | null;
}

